export default {
  namespaced: true,
  state: {
    version: '0.0',
    list: []
  },
  getters: {},
  mutations: {
    setVersion(state, value) {
      state.version = value
    },
    setList(state, value) {
      state.list = value
    }
  },
  actions: {
    setData({ commit }, params) {
      commit('setVersion', params.version)
      commit('setList', params.list)
    }
  }
}
